module.exports = __webpack_public_path__ + "DINNextLTPro-Light.ttf?6abc658409a3bcc7c8820e27f84c1833";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Light.ttf
// module id = 1423
// module chunks = 0